import { render, staticRenderFns } from "./TicketPricing.vue?vue&type=template&id=0826f1d2&scoped=true"
import script from "./TicketPricing.vue?vue&type=script&lang=js"
export * from "./TicketPricing.vue?vue&type=script&lang=js"
import style0 from "./TicketPricing.vue?vue&type=style&index=0&id=0826f1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0826f1d2",
  null
  
)

export default component.exports